import {
  autoUpdate,
  flip,
  offset,
  shift,
  useFloating,
} from '@floating-ui/vue'
import { onClickOutside } from '@vueuse/core'

import type { CSSProperties, Ref } from 'vue'

interface DisciplineProgressReportActionsOptions {
  onEdit: () => void
}

interface DisciplineProgressReportActionsReturn {
  isOpen: Ref<boolean>
  containerRef: Ref<HTMLElement | null>
  floatingRef: Ref<HTMLElement | null>
  floatingStyles: Ref<CSSProperties>
  toggle: () => void
  edit: () => void
}

/** The row menu of a report, as on the Tasks tab; its only action is Edit. */
export const useDisciplineProgressReportActions = (
  options: DisciplineProgressReportActionsOptions,
): DisciplineProgressReportActionsReturn => {
  const isOpen = ref(false)
  const containerRef = ref<HTMLElement | null>(null)
  const floatingRef = ref<HTMLElement | null>(null)

  const { floatingStyles } = useFloating(containerRef, floatingRef, {
    placement: 'bottom-end',
    strategy: 'fixed',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(4),
      flip(),
      shift({ padding: 8 }),
    ],
  })

  const toggle = (): void => {
    isOpen.value = !isOpen.value
  }

  const edit = (): void => {
    isOpen.value = false
    options.onEdit()
  }

  onClickOutside(containerRef, () => {
    isOpen.value = false
  })

  return {
    isOpen,
    containerRef,
    floatingRef,
    floatingStyles,
    toggle,
    edit,
  }
}
